import React from 'react';

import { Button, ButtonProps } from './Button';

interface ButtonLinkProps extends ButtonProps {
    to: string | { [index: string]: any };
}

export const ButtonLink: React.FC<ButtonLinkProps> = ({ to, variant = 'primary', ...restProps }) => {
    return <Button {...restProps} variant={variant} element="a" to={to} />;
};
